import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  IconButton,
  Paper,
  Card,
  CardContent,
  CardActions,
} from "@mui/material";
import { Add, Edit, Delete, PlayArrow} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  const [lessons, setLessons] = useState([]);

  useEffect(() => {
    const savedLessons = JSON.parse(localStorage.getItem("lessons") || "[]");
    setLessons(
      savedLessons.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    );
  }, []);

  const handleDeleteLesson = (id) => {
    if (window.confirm("Bạn có chắc muốn xóa bài học này?")) {
      const updatedLessons = lessons.filter((lesson) => lesson.id !== id);
      localStorage.setItem("lessons", JSON.stringify(updatedLessons));
      setLessons(updatedLessons);
    }
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 4 }}>
          <Typography variant="h4" component="h1" sx={{ flexGrow: 1 }}>
            Bài học của tôi
          </Typography>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => navigate("/create")}
            sx={{
              bgcolor: "#2196f3",
              color: "white",
              "&:hover": {
                bgcolor: "#1976d2",
                transform: "scale(1.05) translateY(-2px)",
                boxShadow: "0 6px 20px rgba(33, 150, 243, 0.3)",
              },
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              px: 4,
              py: 1.5,
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(33, 150, 243, 0.2)",
              fontSize: "1.1rem",
              fontWeight: 600,
              textTransform: "none",
              letterSpacing: "0.5px",
            }}
          >
            Tạo bài học mới
          </Button>
        </Box>

        {lessons.length === 0 ? (
          <Paper
            sx={{
              p: 6,
              textAlign: "center",
              bgcolor: "background.default",
              borderRadius: 4,
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
              maxWidth: 600,
              mx: "auto",
            }}
          >
            <Typography variant="h5" color="text.secondary" sx={{ mb: 3 }}>
              Bạn chưa có bài học nào
            </Typography>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => navigate("/create")}
              sx={{
                bgcolor: "#2196f3",
                color: "white",
                "&:hover": {
                  bgcolor: "#1976d2",
                  transform: "scale(1.05) translateY(-2px)",
                  boxShadow: "0 6px 20px rgba(33, 150, 243, 0.3)",
                },
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                px: 4,
                py: 1.5,
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(33, 150, 243, 0.2)",
                fontSize: "1.1rem",
                fontWeight: 600,
                textTransform: "none",
                letterSpacing: "0.5px",
              }}
            >
              Tạo bài học đầu tiên
            </Button>
          </Paper>
        ) : (
          <Box
            sx={{
              display: "grid",
              gap: 3,
              gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
            }}
          >
            {lessons.map((lesson) => (
              <Card
                key={lesson.id}
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: 6,
                  },
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" component="h2" sx={{ mb: 1 }}>
                    {lesson.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {lesson.words.length} từ vựng
                  </Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: "block", mt: 1 }}
                  >
                    Tạo lúc: {new Date(lesson.createdAt).toLocaleDateString()}
                  </Typography>
                </CardContent>
                <CardActions sx={{ p: 2, pt: 0 }}>
                  <Button
                    size="small"
                    startIcon={<PlayArrow />}
                    onClick={() => navigate(`/lesson/${lesson.id}`)}
                    sx={{ flexGrow: 1 }}
                  >
                    Học
                  </Button>
                  <IconButton
                    size="small"
                    onClick={() => navigate(`/lesson/${lesson.id}/edit`)}
                  >
                    <Edit />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => handleDeleteLesson(lesson.id)}
                  >
                    <Delete />
                  </IconButton>
                </CardActions>
              </Card>
            ))}
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default Home;
